/* QuadrantState.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events");
const DefaultLmrbIcon = "branding.control";

class QuadrantState extends EventEmitter {
    constructor(name, dependencyInjector) {
        super();

        this._name = name;
        this._state = {};
        if (name === "bottom") {
            //let solutionsManager = dependencyInjector.getRegistered("$teve.solutionsManager").registeredObj;
            //let solutionName = (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
            this._state.pinned = true;
        } else {
            this._state.pinned = false;
        }

        this._state._optionsOpened = false;
        this._state._menuVis = false;
        this._state.openedPartId = null;
        this._state.fullScreen = false;
        this._disabled = true;
        this._state._parts = [];
        this._state._availableParts = [];
        this._di = dependencyInjector;
        this._resizeThrottleFunc = _.throttle(this.quadrantSizeChanged, 100, {trailing: true});
    }

    get DI() {
        return this._di;
    }

    get disabled() {
        return this.getDisabled();
    }

    getDisabled() {
        return this._disabled;
    }

    set disabled(val) {
        this.setDisabled(val);
    }

    setDisabled(val, silent) {
        this._disabled = val;
        if (!silent) {
            this.stateChanged();
        }
    }

    togglePinned() {
        this.pinned = !this.pinned;
    }

    setPinned(val, silent) {
        if (val !== this._state.pinned) {
            this._state.pinned = val;
            if (!silent) {
                this.stateChanged();
            }
        }
    }

    get pinned() {
        return this._state.pinned;
    }

    set pinned(val) {
        this.setPinned(val);
    }

    toggleFullScreen() {
        this.fullScreen = !this.fullScreen;
    }

    setFullScreen(val, silent) {
        if (val !== this._state.fullScreen) {
            this._state.fullScreen = val;
            if (!silent) {
                this.stateChanged();
            }
        }
    }

    get fullScreen() {
        return this._state.fullScreen;
    }

    set fullScreen(val) {
        this.setFullScreen(val);
    }

    setOptionsOpened(val, silent) {
        if (val !== this._state.optionsOpened) {
            this._state.optionsOpened = val;
            if (!silent) {
                this.stateChanged();
            }
        }
    }

    get optionsOpened() {
        return this._state.optionsOpened;
    }

    set optionsOpened(val) {
        this.setOptionsOpened(val);
    }

    toggleOptionsOpened() {
        this.optionsOpened = !this.optionsOpened;
    }

    get menuVisible() {
        return this._state._menuVis;
    }

    set menuVisible(val) {
        if (val !== this._menuVis && !this._state.pinned) {
            this._state._menuVis = val;
            this.stateChanged();
        }
    }

    get activePartIds() {
        let partIds = [];
        _.forEach(this.getActiveParts(), (part) => {
            partIds.push(part.id);
        });
        return partIds;
    }

    get availablePartsIds() {
        let partsIds = [];
        _.forEach(this.availableParts, (part) => {
            partsIds.push(part.name);
        });
        return partsIds;
    }

    getActiveParts() {
        return this._state._parts;
    }

    getNonActiveAvailablePartsIds() {
        return _.difference(this.availablePartsIds, this.activePartIds);
    }

    getActivePart(id) {
        let partObj = this._state._parts.find((part) => part.id === id);
        if (partObj) {
            return partObj;
        } else {
            return false;
        }
    }

    addPart(name, id, options, silent) {
        let partToAdd = this.getAvailablePart(name);
        if (partToAdd) {
            let iconRepoName = _.get(
                partToAdd,
                "iconRepoName",
                _.get(options, "$iconRepoName", DefaultLmrbIcon)
            );
            let displayName = _.get(partToAdd, "displayName", _.get(options, "$displayName", name));

            //Check to see if part is already active, if so do nothing.
            this._state._parts.push({
                id: id,
                name: name,
                displayName: displayName,
                iconRepoName: iconRepoName,
                maxByDefault: partToAdd.maxByDefault,
            });

            if (!silent) {
                this.stateChanged();
            }
        } else {
            throw new Error(
                "Cannot add part, there is no registered part with the name " +
                    name +
                    " in the " +
                    this._name +
                    " quadrant"
            );
        }
    }

    removePart(id, silent) {
        if (this._state._parts.length > 1) {
            _.remove(this._state._parts, (part) => part.id === id);
            if (this.openedPartId === id) {
                this.setOpenedPartId(null, true);
            }
            if (!silent) {
                this.stateChanged();
            }
        }
    }

    get availableParts() {
        return this._state._availableParts;
    }

    addAvailablePart(partDescription) {
        if (!this.getAvailablePart(partDescription.name)) {
            this.availableParts.push(partDescription);
        } else {
            throw new Error(
                "an available part with the name " +
                    partDescription.name +
                    "already exists in the " +
                    this._name +
                    "quadrant"
            );
        }
        if (this.availableParts.length > 0 && this.disabled) {
            this.setDisabled(false, true);
        }
    }

    getAvailablePart(name) {
        return this._state._availableParts.find((part) => part.name === name);
    }

    removeAllParts(silent) {
        this.setOpenedPartId(null);
        this._state._parts = [];
        this._state._availableParts = [];
        if (!silent) {
            this.stateChanged();
        }
    }

    setOpenedPartId(val, silent) {
        if (val !== this._state.openedPartId) {
            this._state.openedPartId = val;
            if (!silent) {
                this.stateChanged();
            }
        }
    }

    getOpenedpartId() {
        return this._state.openedPartId;
    }

    get openedPartId() {
        return this.getOpenedpartId();
    }

    set openedPartId(val) {
        this.setOpenedPartId(val);
    }

    setOpenedSize(val, silent) {
        this._state.openedSize = val;
        if (!silent) {
            this.stateChanged();
            this._resizeThrottleFunc();
        }
    }

    getOpenedSize() {
        return this._state.openedSize;
    }

    get openedSize() {
        return this.getOpenedSize();
    }

    set openedSize(val) {
        this.setOpenedSize(val);
    }

    stateChanged() {
        //console.log(this.toJSON());
        this.emit("stateChanged", this.toJSON());
    }

    notifyPartSizeChanged() {
        this.emit("sizeChanged");
    }

    quadrantSizeChanged() {
        this.emit("quadrantSizeChanged");
    }

    toJSON() {
        let that = this;
        return {
            openedPartId: that.openedPartId,
            pinned: that.pinned,
            openedSize: that.openedSize,
            fullScreen: that.fullScreen,
            parts: that.getActiveParts(),
        };
    }

    _setIfProvided(obj, prop) {
        if (_.hasIn(obj, prop)) {
            this._state[prop] = obj[prop];
        }
    }

    updateState(stateObj) {
        this._setIfProvided(stateObj, "pinned");
        this._setIfProvided(stateObj, "openedSize");
        this._setIfProvided(stateObj, "openedPartId");
        this._setIfProvided(stateObj, "fullScreen");
        this._setActiveParts(_.get(stateObj, "parts", []));
    }

    _setActiveParts(partArray) {
        //let partsIdsToRemove = this.activePartIds;
        partArray.forEach((partObj) => {
            const partId = _.get(partObj, "id");
            if (!this.getActivePart(partId)) {
                let options = {
                    $iconRepoName: _.get(partObj, "$iconRepoName", DefaultLmrbIcon),
                    $displayName: _.get(
                        partObj,
                        "$displayName",
                        _.get(partObj, "displayName", partObj.name)
                    ),
                };
                this.addPart(partObj.name, _.get(partObj, "id", partObj.name), options, false);
            } // else {
            //    _.pull(partsIdsToRemove, partId);
            //}
        });
        //Changes 23054
        //partsIdsToRemove.forEach((partIdToRemove) => {
        //    this.removePart(partIdToRemove);
        //});
    }
}

module.exports = QuadrantState;
